import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { PopUpDialogService } from 'src/app/services/popup-dialog.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom } from 'rxjs';
import { PushNotificationRequest } from 'src/app/core/model/server/vo/PushNotificationRequest.interface';
@Injectable({
  providedIn: 'root'
})
export class PushNotificationService {

  constructor(
    private apiService: ApiService,
    private popUpDialogService: PopUpDialogService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private toastr: ToastrService
  ) { }

  async changeStatus(uid: number, value: number) {
    try {
      this.spinner.show().catch((err) => {
        console.error('Spinner show error:', err);
      });


      const response = await firstValueFrom(
        this.apiService.setStatusPushNotification(uid, value)
      );


      if (response.status === 200) {
        const action = value === 0 ? 'enabled' : 'disabled';
        this.popUpDialogService.openSuccessDialog(
          `Push notification has been ${action} successfully!`
        );
        
        this.spinner.hide().catch((err) => {
          console.error('Spinner hide error:', err);
        });
        
      } else {
        this.popUpDialogService.openErrorDialog(
          'Failed to update status. Please try again.'
        );
        
        this.spinner.hide().catch((err) => {
          console.error('Spinner hide error:', err);
        });
      }

    } catch (error) {
      const errorMessage = error?.error?.message || error?.message || 'Something went wrong!';
      this.popUpDialogService.openErrorDialog(errorMessage);
      
      this.spinner.hide().catch((err) => {
        console.error('Spinner hide error:', err);
      });
    }
  }

  async performStore(data: PushNotificationRequest): Promise<void> {
    try {
      this.spinner.show().catch((err) => {
        console.error('Spinner show error:', err);
      });

      const formData = new FormData();
      
      formData.append('title', data.title);
      formData.append('message', data.message);
      
      // Add cover image if exists
      if (data.coverImage) {
        formData.append('coverImage', data.coverImage);
      }
      
      // Add feature image if exists
      if (data.featureImage) {
        formData.append('featureImage', data.featureImage);
      }

      const response = await firstValueFrom(
        this.apiService.storePushNotifications(formData)
      );

      
      if (response.status === 200 || response.status === 201) {
        this.popUpDialogService.openSuccessDialog(
          'Push notification has been saved successfully!'
        );
      } else {
        this.popUpDialogService.openErrorDialog(
          'Failed to create push notification. Please check all fields and try again.'
        );
      }

      this.spinner.hide().catch((err) => {
        console.error('Spinner hide error:', err);
      });

    } catch (error) {
      this.popUpDialogService.openErrorDialog('Failed to create push notification. Please try again. (Don\'t use emojis since its still under development😃)');
      
      this.spinner.hide().catch((err) => {
        console.error('Spinner hide error:', err);
      });
      
      throw error; 
    }
  }

  async performUpdate(data: PushNotificationRequest): Promise<void> {
    try {
      this.spinner.show().catch((err) => {
        console.error('Spinner show error:', err);
      });

      const formData = new FormData();
      
      formData.append('title', data.title);
      formData.append('message', data.message);

      // Only append cover image if new one was selected
      if (data.coverImage) {
        formData.append('coverImage', data.coverImage);
      }

      // Only append feature image if new one was selected
      if (data.featureImage) {
        formData.append('featureImage', data.featureImage);
      }


      if(data.uid === undefined || data.uid === null) {
        throw new Error('Push notification UID is required for update.');
      }

      // Use the API service method
      const response = await firstValueFrom(
        this.apiService.updatePushNotification(formData, data.uid)
      );


      if (response.status === 200) {
        this.popUpDialogService.openSuccessDialog(
          'Push notification has been updated successfully!',
          () => {
            // Navigate ONLY after OK click
            this.router.navigate(['/features/push-notification']).catch((err) => {
              this.toastr.error('Navigation error:', err);
            });
          }
        );
        
      } else {
        const errorMsg = response?.error?.message || 'Failed to update push notification';
        this.popUpDialogService.openErrorDialog(errorMsg);
      }

    } catch (error) {
      const errorMessage = error?.error?.message || error?.message || 'Something went wrong!';
      this.popUpDialogService.openErrorDialog(errorMessage);
    } finally {
        this.spinner.hide().catch((err) => {
          console.error('Spinner hide error:', err);
        });
    }
  }
}
